import {Modal} from 'react-bootstrap'
import React from 'react'
import PropTypes from 'prop-types'
import './ApplicationIDSecretInfoModal.css'

class ApplicationIDSecretInfoModal extends React.Component {
  render () {
    const {show, app} = this.props

    return <Modal show={show}>
      <Modal.Header bsClass='modal-primary modal-header'>
        <span>Application ID and Secret</span>
      </Modal.Header>
      <Modal.Body>
        <h4>Application ID</h4>
        <code>{app.uid}</code>
        <h4>Application Secret</h4>
        <code>{app.secret}</code>
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-primary' onClick={this._onClickConfirm}>OK</button>
      </Modal.Footer>
    </Modal>
  }

  _onClickConfirm = () => {
    this.props.onClickConfirm({})
  }
}

ApplicationIDSecretInfoModal.propTypes = {
  show: PropTypes.bool,
  content: PropTypes.string,
  onClickConfirm: PropTypes.func
}

export default ApplicationIDSecretInfoModal



// WEBPACK FOOTER //
// app/javascript/components/frags/ApplicationIDSecretInfoModal/ApplicationIDSecretInfoModal.js